import React from "react";

const WFIRSSQuestion6 = ({ questions, renderRadioInputs, questionKey }) => (
  <div key={`WFIRSSQuestion6${questionKey}`}>
    <div className="wfirs-progress-row">
      <div className="wfirs-progress-bar">
        <div style={{ width: "85.7%" }}></div>
      </div>
      <span className="wfirs-counter">6 / 7</span>
    </div>
    <h2 className="wfirs-section-title">Click the number for the rating that best describes how your emotional or behavioral problems have affected your Social Activities.</h2>
    {questions.slice(46, 55).map((question, index) => (
      <div className="wfirs-question" key={index}>
        <label className="wfirs-q-label">{index + 47}. {question.questions}</label>
        {renderRadioInputs(index + 47)}
      </div>
    ))}
  </div>
);

export default WFIRSSQuestion6;
